import strapi, { getAllPages } from 'utils/strapi';

import { Box } from 'atomic-layout';
import PageTitle from 'components/layout/pageTitle';
import SEO from 'components/seo';
import dynamic from 'next/dynamic';
import { getFooterProps } from 'components/layout/footer';
import { getHeaderProps } from 'components/layout/header';
import { getLoaderProps } from 'components/loader';

const BlogList = dynamic(() => import('components/content/blog-list'));

export default function BlogIndexPage({ seoData, title, blogs }) {
  return (
    <Box padding={1}>
      <SEO {...seoData} />
      <PageTitle $marginBottom={'5rem'} title={title} />
      <BlogList blogs={blogs} />
    </Box>
  );
}

export async function getStaticProps(ctx) {
  let result;
  try {
    result = await strapi('/api/blogs-index-page', {
      populate: ['seo', 'seo.openGraphImage'],
    });
  } catch (err) {
    return {
      notFound: true,
    };
  }
  const { title, seo } = result.data.attributes;
  const blogs = await getAllPages('/api/blog-posts', {
    populate: ['thumbnailImage'],
    sort: ['publishedAt:desc'],
  });

  return {
    props: {
      seoData: seo,
      title,
      blogs,
      footerProps: await getFooterProps(),
      headerProps: await getHeaderProps(),
      loaderProps: await getLoaderProps(),
    },
  };
}
